module.exports = __webpack_public_path__ + "static/media/leaseInactive.c836c653.svg";